const addToCart = document.querySelector('#AddToCart');

const cartAddedImage = document.querySelector('#js-cart-added-image');
const cartAddedTitle = document.querySelector('#js-cart-added-title');
const cartAddedOptions = document.querySelector('#js-cart-added-options');
const cartAddedPrice = document.querySelector('#js-cart-added-price');
const cartAddedProduct = document.querySelector('.cart-added-modal__product');
const cartAddedQtyInput = document.querySelector('#js-cart-added-qty-input');
const cartAddedQtyMinus = document.querySelector('#js-cart-added-qty-minus');
const cartAddedQtyPlus = document.querySelector('#js-cart-added-qty-plus');
const cartAddedDelete = document.querySelector('#js-cart-added-delete');

const cartAddedModalWrapper = document.querySelector('.modalWrapper.cart-added-modal');
const cartAddedViewAdded = document.querySelector('#js-cart-added-view-added');
const cartAddedViewSelect = document.querySelector('#js-cart-added-view-select');
const cartAddedSelectPanels = document.querySelectorAll('.cart-added-select__panel');

// currentCartLine tracks only the quantity added by *this* add-to-cart action,
// separate from whatever quantity of the same variant was already in the cart.
let currentCartLine = null;
let isUpdatingCartLine = false;
let recommendSplide = null;
let recommendScrollHint = null;

const formatMoney = (cents) => `¥${Math.round(cents / 100).toLocaleString('ja-JP')}`;

// unitPrice/originalUnitPrice come straight off the cart line, so this
// picks up any quantity-break (line-level) discount automatically —
// cart-/order-level discounts aren't reflected in these fields.
const updateCartAddedPrice = (unitPrice, originalUnitPrice, quantity) => {
  if (!cartAddedPrice) return;
  const finalTotal = formatMoney(unitPrice * quantity);

  if (originalUnitPrice > unitPrice) {
    const originalTotal = formatMoney(originalUnitPrice * quantity);
    cartAddedPrice.innerHTML = `<s class="cart-added-modal__product-price-original">${originalTotal}</s> ${finalTotal}<small>（税込）</small>`;
  } else {
    cartAddedPrice.innerHTML = `${finalTotal}<small>（税込）</small>`;
  }
};

const renderCartAddedProduct = (item, justAddedQuantity) => {
  if (!cartAddedImage) return;

  currentCartLine = {
    key: item.key,
    unitPrice: item.final_price,
    originalUnitPrice: item.original_price || item.price,
    justAddedQuantity: justAddedQuantity,
    preExistingQuantity: item.quantity - justAddedQuantity,
  };

  cartAddedImage.src = item.featured_image ? item.featured_image.url : item.image;
  cartAddedImage.alt = item.product_title;
  cartAddedTitle.textContent = item.product_title;

  cartAddedOptions.innerHTML = '';
  (item.options_with_values || []).forEach((option) => {
    if (option.value === 'Default Title') return;
    const li = document.createElement('li');
    li.textContent = `${option.name} : ${option.value}`;
    cartAddedOptions.appendChild(li);
  });

  if (cartAddedQtyInput) cartAddedQtyInput.value = justAddedQuantity;
  if (cartAddedProduct) cartAddedProduct.hidden = false;
  updateCartAddedPrice(currentCartLine.unitPrice, currentCartLine.originalUnitPrice, justAddedQuantity);
};

const updateCartCountBubble = (itemCount) => {
  const cartItemCounts = document.querySelectorAll('.cart-icon-bubble-link');
  const cartCountStr = `
                  <div class="cart-count-bubble">
                      <span aria-hidden="true"></span>
                  </div>`;
  const dummyDiv = document.createElement('div');
  dummyDiv.innerHTML = cartCountStr;
  dummyDiv.querySelector('span').textContent = itemCount;

  cartItemCounts.forEach((cartItemCount) => {
    const existingCountBubble = cartItemCount.querySelector('.cart-count-bubble');
    if (existingCountBubble) {
      existingCountBubble.remove();
    }
    cartItemCount.appendChild(dummyDiv.firstElementChild.cloneNode(true));
  });
};

// Sends the *total* line quantity (pre-existing + just-added) to Shopify,
// so adjusting the modal's stepper never touches quantity that was already
// in the cart before this add-to-cart action.
const changeCartLineQuantity = (totalQuantity) => {
  return fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: currentCartLine.key, quantity: totalQuantity }),
  }).then((response) => response.json());
};

const setJustAddedQuantity = (newJustAddedQuantity) => {
  if (!currentCartLine || isUpdatingCartLine) return;
  isUpdatingCartLine = true;
  const totalQuantity = currentCartLine.preExistingQuantity + newJustAddedQuantity;

  changeCartLineQuantity(totalQuantity)
    .then((cart) => {
      updateCartCountBubble(cart.item_count);

      // Re-read price off the fresh cart line: crossing a quantity-break
      // threshold up or down can change the discounted unit price.
      const updatedLine = cart.items.find((cartItem) => cartItem.key === currentCartLine.key);
      if (updatedLine) {
        currentCartLine.unitPrice = updatedLine.final_price;
        currentCartLine.originalUnitPrice = updatedLine.original_price || updatedLine.price;
      }

      currentCartLine.justAddedQuantity = newJustAddedQuantity;
      if (cartAddedQtyInput) cartAddedQtyInput.value = newJustAddedQuantity;
      updateCartAddedPrice(currentCartLine.unitPrice, currentCartLine.originalUnitPrice, newJustAddedQuantity);
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      isUpdatingCartLine = false;
    });
};

const removeJustAddedItem = () => {
  if (!currentCartLine || isUpdatingCartLine) return;
  isUpdatingCartLine = true;

  changeCartLineQuantity(currentCartLine.preExistingQuantity)
    .then((cart) => {
      updateCartCountBubble(cart.item_count);
      currentCartLine = null;
      if (cartAddedProduct) cartAddedProduct.hidden = true;
      modalClose();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      isUpdatingCartLine = false;
    });
};

if (cartAddedQtyMinus) {
  cartAddedQtyMinus.addEventListener('click', () => {
    if (!currentCartLine || currentCartLine.justAddedQuantity <= 1) return;
    setJustAddedQuantity(currentCartLine.justAddedQuantity - 1);
  });
}

if (cartAddedQtyPlus) {
  cartAddedQtyPlus.addEventListener('click', () => {
    if (!currentCartLine) return;
    setJustAddedQuantity(currentCartLine.justAddedQuantity + 1);
  });
}

if (cartAddedQtyInput) {
  cartAddedQtyInput.addEventListener('change', () => {
    if (!currentCartLine) return;
    const newQuantity = parseInt(cartAddedQtyInput.value, 10);
    if (!newQuantity || newQuantity < 1) {
      cartAddedQtyInput.value = currentCartLine.justAddedQuantity;
      return;
    }
    setJustAddedQuantity(newQuantity);
  });
}

if (cartAddedDelete) {
  cartAddedDelete.addEventListener('click', () => {
    removeJustAddedItem();
  });
}

// Posts to /cart/add.js, then re-fetches the full cart and reads this line back
// from it, rather than trusting cart/add.js's own response: discount allocations
// (e.g. a quantity-break discount just crossed by this add) are only guaranteed
// final once the whole cart has been recalculated.
const submitAddToCart = (requestInit, requestedQuantity) => {
  return fetch(window.Shopify.routes.root + 'cart/add.js', requestInit)
    .then((response) => response.json())
    .then((addedItem) => {
      if (addedItem.status) {
        throw new Error(addedItem.description || 'カートへの追加に失敗しました');
      }
      // The form POST returns the line itself, the JSON `items` POST wraps it in an array.
      const addedLine = addedItem.items ? addedItem.items[0] : addedItem;
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((cart) => ({ addedLine, cart }));
    })
    .then(({ addedLine, cart }) => {
      updateCartCountBubble(cart.item_count);
      const cartLine = cart.items.find((cartItem) => cartItem.key === addedLine.key) || addedLine;
      renderCartAddedProduct(cartLine, requestedQuantity);
    });
};

const addVariantToCart = (variantId, quantity) => {
  return submitAddToCart(
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] }),
    },
    quantity
  );
};

addToCart.addEventListener('click', (e) => {
  e.preventDefault();
  const addToCartForm = document.querySelector('form[action$="/cart/add"]');
  const formData = new FormData(addToCartForm);
  const requestedQuantity = parseInt(formData.get('quantity'), 10) || 1;

  submitAddToCart({ method: 'POST', body: formData }, requestedQuantity)
    .then(() => {
      showAddedView();
      modalOpen();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
});

// ScrollHint は初期化時と window の scroll / resize 時にしか幅・表示位置を測らないため、
// display:none のモーダル内で先に初期化すると「スクロール不可」と判定されてしまう。
// そのためモーダルが表示されきった後に初期化し、以降の開閉では再計測だけ行う。
// また、モーダル内のスクロールは window の scroll イベントを発火しないので、
// モーダル自体の scroll でも再計測してヒントの表示タイミングを拾う。
const initRecommendScrollHint = () => {
  if (recommendScrollHint) {
    recommendScrollHint.updateItems();
    return;
  }
  if (typeof ScrollHint === 'undefined') return;

  const list = document.querySelector('.cart-added-recommend__list');
  if (!list) return;

  recommendScrollHint = new ScrollHint(list, {
    i18n: {
      scrollable: 'スクロールできます',
    },
  });

  if (cartAddedModalWrapper) {
    cartAddedModalWrapper.addEventListener('scroll', () => recommendScrollHint.updateItems(), { passive: true });
  }
};

let modalOpen = () => {
  $('#modalArea').fadeIn(initRecommendScrollHint);
};

let modalClose = () => {
  $('#modalArea').fadeOut();
  // Always reopen on the "added" view, never on a half-filled variant picker.
  showAddedView();
};

$('#closeModal1 , #modalBg , #closeModal2').click(function (e) {
  e.preventDefault();
  modalClose();
});

/* ------------------------------------------------------------------
   あなたへのおすすめ（related_products）
   バリエーションを持たない商品はカードからワンクリックで追加し、
   バリエーション（STYLE / COLOR / SET など）を持つ商品は
   同じモーダル内のバリエーション選択ビューへ切り替えてから追加する。
------------------------------------------------------------------ */

const scrollModalToTop = () => {
  if (cartAddedModalWrapper) cartAddedModalWrapper.scrollTop = 0;
};

const showAddedView = () => {
  if (!cartAddedViewAdded) return;
  if (cartAddedViewSelect) cartAddedViewSelect.hidden = true;
  cartAddedViewAdded.hidden = false;
  // ①のドロワー型シェルに戻す（②は独立した中央ダイアログ / ボトムシート）。
  if (cartAddedModalWrapper) cartAddedModalWrapper.classList.remove('--select-shell');
  // Splide can't measure its slides while the view is hidden, so re-measure here.
  if (recommendSplide) recommendSplide.refresh();
  // バリエーション選択ビューから戻った直後もリストの幅を測り直す。
  if (recommendScrollHint) recommendScrollHint.updateItems();
  scrollModalToTop();
};

const getSelectPanelVariants = (panel) => {
  if (!panel.variantData) {
    panel.variantData = JSON.parse(panel.querySelector('[data-select-variants]').textContent);
  }
  return panel.variantData;
};

// Radios are rendered in option position order, so the checked values line up
// with each variant's `options` array index for index.
const getSelectedVariant = (panel) => {
  const selectedValues = Array.from(panel.querySelectorAll('[data-select-option]:checked')).map(
    (input) => input.value
  );
  return getSelectPanelVariants(panel).find((variant) =>
    selectedValues.every((value, index) => variant.options[index] === value)
  );
};

const showSelectError = (panel, message) => {
  const errorEl = panel.querySelector('[data-select-error]');
  if (!errorEl) return;
  errorEl.textContent = message;
  errorEl.hidden = !message;
};

// 「選択中」ボックス（Figmaの選択サマリー）を、各fieldsetのlegend（オプション名）と
// 現在チェックされているラジオのvalueから組み立てる。STYLE/COLOR/SETという名前を
// 決め打ちにせず、商品ごとのオプション構成にそのまま対応する。
const updateSelectSummary = (panel) => {
  const summaryValuesEl = panel.querySelector('[data-select-summary-values]');
  if (!summaryValuesEl) return;

  const lines = Array.from(panel.querySelectorAll('.cart-added-select__option')).map((fieldset) => {
    const legend = fieldset.querySelector('legend');
    const checked = fieldset.querySelector('[data-select-option]:checked');
    return `${legend ? legend.textContent.trim() : ''}：${checked ? checked.value : ''}`;
  });

  summaryValuesEl.innerHTML = lines.map((line) => `<p>${line}</p>`).join('');
};

const refreshSelectPanel = (panel) => {
  const variant = getSelectedVariant(panel);
  const priceEl = panel.querySelector('[data-select-price]');
  const imageEl = panel.querySelector('[data-select-image]');
  const addBtn = panel.querySelector('[data-select-add]');

  showSelectError(panel, '');
  updateSelectSummary(panel);

  if (!variant) {
    if (priceEl) priceEl.innerHTML = '';
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'この組み合わせは選択できません';
    }
    return;
  }

  if (priceEl) {
    const price = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML = `<s class="cart-added-modal__product-price-original">${formatMoney(
        variant.compare_at_price
      )}</s> ${price}<small>（税込）</small>`;
    } else {
      priceEl.innerHTML = `${price}<small>（税込）</small>`;
    }
  }

  if (imageEl && variant.featured_image && variant.featured_image.src) {
    imageEl.src = variant.featured_image.src;
  }

  if (addBtn) {
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? 'カートに追加する' : '売り切れ';
  }
};

const getSelectQuantity = (panel) => {
  const input = panel.querySelector('[data-select-qty-input]');
  const quantity = parseInt(input.value, 10);
  return !quantity || quantity < 1 ? 1 : quantity;
};

const setSelectQuantity = (panel, quantity) => {
  const input = panel.querySelector('[data-select-qty-input]');
  input.value = quantity < 1 ? 1 : quantity;
};

const showSelectView = (handle) => {
  if (!cartAddedViewSelect || !cartAddedViewAdded) return false;

  let targetPanel = null;
  cartAddedSelectPanels.forEach((panel) => {
    const isTarget = panel.dataset.productHandle === handle;
    panel.hidden = !isTarget;
    if (isTarget) targetPanel = panel;
  });
  if (!targetPanel) return false;

  setSelectQuantity(targetPanel, 1);
  refreshSelectPanel(targetPanel);

  cartAddedViewAdded.hidden = true;
  cartAddedViewSelect.hidden = false;
  // ②リニューアルモーダル（Figma node 4066:444 / 4066:552）専用の中央ダイアログ／
  // ボトムシートのシェルに切り替える。
  if (cartAddedModalWrapper) cartAddedModalWrapper.classList.add('--select-shell');
  scrollModalToTop();
  return true;
};

const addSelectPanelToCart = (panel) => {
  const variant = getSelectedVariant(panel);
  if (!variant || !variant.available) {
    showSelectError(panel, '選択された組み合わせは現在購入できません');
    return;
  }

  const quantity = getSelectQuantity(panel);
  const addBtn = panel.querySelector('[data-select-add]');
  if (addBtn) addBtn.disabled = true;

  addVariantToCart(variant.id, quantity)
    .then(() => {
      showAddedView();
    })
    .catch((error) => {
      console.error('Error:', error);
      showSelectError(panel, error.message || 'カートへの追加に失敗しました');
    })
    .finally(() => {
      if (addBtn) addBtn.disabled = false;
    });
};

cartAddedSelectPanels.forEach((panel) => {
  panel.querySelectorAll('[data-select-option]').forEach((input) => {
    input.addEventListener('change', () => refreshSelectPanel(panel));
  });

  const qtyMinus = panel.querySelector('[data-select-qty-minus]');
  const qtyPlus = panel.querySelector('[data-select-qty-plus]');
  const qtyInput = panel.querySelector('[data-select-qty-input]');

  if (qtyMinus) qtyMinus.addEventListener('click', () => setSelectQuantity(panel, getSelectQuantity(panel) - 1));
  if (qtyPlus) qtyPlus.addEventListener('click', () => setSelectQuantity(panel, getSelectQuantity(panel) + 1));
  if (qtyInput) qtyInput.addEventListener('change', () => setSelectQuantity(panel, getSelectQuantity(panel)));

  const addBtn = panel.querySelector('[data-select-add]');
  if (addBtn) addBtn.addEventListener('click', () => addSelectPanelToCart(panel));

  // 商品ページ本体の js-color-slider（VariantSelects.handleArrowClick, assets/global.js）と
  // 同じロジック：画像横の矢印でCOLORオプションを前後に送る。
  const imagePrevBtn = panel.querySelector('[data-select-image-prev]');
  const imageNextBtn = panel.querySelector('[data-select-image-next]');

  const cycleColorOption = (direction) => {
    const colorOptions = Array.from(panel.querySelectorAll('input.option-color'));
    if (colorOptions.length === 0) return;
    const selectedIndex = colorOptions.findIndex((option) => option.checked);
    let newIndex = selectedIndex + direction;
    if (newIndex < 0) {
      newIndex = colorOptions.length - 1;
    } else if (newIndex >= colorOptions.length) {
      newIndex = 0;
    }
    colorOptions[newIndex].checked = true;
    colorOptions[newIndex].dispatchEvent(new Event('change', { bubbles: true }));
  };

  if (imagePrevBtn) imagePrevBtn.addEventListener('click', () => cycleColorOption(-1));
  if (imageNextBtn) imageNextBtn.addEventListener('click', () => cycleColorOption(1));

  refreshSelectPanel(panel);
});

document.querySelectorAll('.js-cart-added-recommend-add').forEach((button) => {
  button.addEventListener('click', () => {
    const variantId = button.dataset.variantId;

    // No variant id means the product has STYLE / COLOR / SET options, which
    // can't be resolved from a single click — switch to the variant picker.
    if (!variantId) {
      showSelectView(button.dataset.productHandle);
      return;
    }

    button.disabled = true;
    addVariantToCart(variantId, 1)
      .then(() => {
        showAddedView();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        button.disabled = false;
      });
  });
});
